module.exports = __webpack_public_path__ + "img/bullhorn.3dd2b116.svg";